const AffiliationPage = () => import('./view/AffiliationPage.vue');

const routes = [
  {
    path: '/affiliation',
    name: 'affiliation',
    component: AffiliationPage,
    meta: {
      title: 'Affiliation',
      requiresAuth: true
    }
  }
];

export default routes;
